




























































import {
  Vue,
  Component
} from "@/shared/vuepack";
import { ToHome } from "@/shared/route-names";
import {
  Reports,
  Utility,
  AdvisorRuleList3,
  AdvisorActionList3,
  SigningDocuments,
  ConsumerSearch
} from "@/admin/route-names";
import _ from "lodash";
import { UserPermission } from "@/shared/types";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useUserStore } from "@/shared/store/user";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";

@Component
export default class Header extends Vue {

  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  rolePermissionsStore = useRolePermissionsStore();

  ToHome = ToHome;
  Reports = Reports;
  Utility = Utility;
  ConsumerSearch = ConsumerSearch;
  AdvisorRuleList3 = AdvisorRuleList3;
  AdvisorActionList3 = AdvisorActionList3;
  SigningDocuments = SigningDocuments;

  get hasEmployerAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerEdit);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEmployerView);
    return hasEditPermission || hasViewPermission;
  }

  get hasPartnerAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
    return (hasEditPermission || hasViewPermission);
  }

  get hasAdvisorAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalAdvisorView);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalAdvisorEdit);
    return (hasEditPermission || hasViewPermission);
  }

  get hasSigningAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDocumentEdit);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalDocumentView);
    return ( hasEditPermission || hasViewPermission);
  }

  get hasReportsAccess (): boolean {
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalReportsView);
    return (hasViewPermission);
  }

  get hasUserManagementAccess (): boolean {
    const hasEditPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementEdit);
    const hasViewPermission = this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUserManagementView);
    // Since userHasAdminPermission is defaulting to true if hsa4475allowRolePermissions is off.
    return ((this.adminPortalRolesEnabled && (hasEditPermission || hasViewPermission)) || this.featureFlagStore.flags.hsa7246AdminInitialUserCreation );
  }

  get hasUtilityAccess (): boolean {
    const hasGlobalPermission = this.rolePermissionsStore.userHasAdminPermission(
                                            UserPermission.AdminPortalUtilityGlobalRolePermissionEdit);
    const hasQuickSightPermission = this.rolePermissionsStore.userHasAdminPermission(
                                            UserPermission.AdminPortalUtilityQuickSightReptEdit);
    const hasDebicCardPermission = this.rolePermissionsStore.userHasAdminPermission(
                                            UserPermission.AdminPortalUtilityDebitCardCustoEdit);
    const hasDrvWealthRiskAgePortPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityDrvWealthRiskAgePortEdit);
    const hasDrvWealthRiskAgeRevPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityDrvWealthRiskAgeReviEdit);
    const hasDrvWealthInstrLstPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityDrvWealthInstrLstEdit);
    const hasSftpPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilitySftpTestFileEdit);
    const hasOutNotifyConfigPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityOutageNotifyConfigEdit);
    const hasManageEditPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityMobileAppsEdit);
    const hasMobileAppsPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityQuickSightReptEdit);
    const hasOpenSearchPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityOpenSearchEdit);
    const hasAdminPortalDebitCardSettingBulkImport = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalDebitCardSettingBulkImport);
    const hasBrowserRulesPermission = this.rolePermissionsStore.userHasAdminPermission(
                                                            UserPermission.AdminPortalUtilityBrowserRulesEdit);
    return hasGlobalPermission || hasQuickSightPermission || hasDebicCardPermission || hasDrvWealthRiskAgePortPermission
           || hasDrvWealthRiskAgeRevPermission || hasDrvWealthInstrLstPermission || hasSftpPermission
           || hasOutNotifyConfigPermission || hasManageEditPermission || hasMobileAppsPermission
           || hasOpenSearchPermission || hasAdminPortalDebitCardSettingBulkImport || hasBrowserRulesPermission;
  }

  get hasConsumerAccess (): boolean {
    return this.userStore.loggedIn
      && this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalHsaInfoView)
      && this.featureFlagStore.flags.bend26163AdminPortalConsumer;
  }

  get displayName (): string {
    const displayName = _.get(this.userStore, [ "currentUser", "displayName" ], "").trim();
    if (!displayName) {
      return "New User";
    }

    return displayName;
  }

  get isEbtoUser (): boolean {


    return (!this.featureFlagStore.flags.hsa4475allowRolePermissions && this.userStore.currentUser.groups.some(x => x === "ebto-view" || x === "ebto-edit"))
    || (this.userStore.currentUser.groups.some(x => x === "ebto-view" || x === "ebto-edit")
    && !(this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEbtoView)
    || this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalEbtoEdit)));
  }

  get showSecurity (): boolean {
    return true;
  }

  get showDemoConfig (): boolean {
    return this.featureFlagStore.flags.UseDemoDataInjectionTableForDrivewealthMocks;
  }

  get partnerBulkActionsEnabled (): boolean {
    return this.featureFlagStore.flags.partnerBulkActions;
  }

  get showPartnerBulkActions (): boolean {
    return this.partnerBulkActionsEnabled && this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get adminPortalRolesEnabled () {
    return this.featureFlagStore.flags.hsa4475allowRolePermissions;
  }
}
